import { useCallback } from 'react';

import { useDocumentActions } from '../../../../../../store';

export const useHandlers = () => {
  const documentActions = useDocumentActions();

  const handleCollapseClick = useCallback(() => {
    documentActions.closeVariationDetailsPanel();
  }, [documentActions]);

  return {
    handleCollapseClick,
  };
};
